const hopsConfig = require('@xingternal/hops-config');

const { pathOr } = require('../objects');

const getConfig = (key, elseValue = null) => {
  return pathOr(elseValue, [key], hopsConfig);
};

const getPrefixedUrl = (path) => getConfig('apiBaseUrl', '/api') + path;

module.exports = { getConfig, getPrefixedUrl };
